'use client';
import { memo, useMemo } from 'react';
import { Grid } from '@chakra-ui/react';

import ProjectsCasesCard from '../ProjectsCasesCard';

const transformCardsData = cardsData => {
  if (cardsData.length <= 4) return cardsData;

  if (!cardsData.some(({ description = null }) => Boolean(description))) return cardsData;

  const cardsWithDescriptionNeed = Math.floor(cardsData.length / 5);

  const { result, withDescription } = cardsData.reduce(
    (acc, card) => {
      if ('description' in card && acc.withDescription.length < cardsWithDescriptionNeed) {
        acc.withDescription.push(card);
      } else {
        acc.result.push(card);
      }
      return acc;
    },
    { result: [], withDescription: [] },
  );

  const INSERT_INDEX = 4;

  withDescription.forEach((card, i) => result.splice(INSERT_INDEX * (i + 1) + i, 0, card));

  return result;
};

const CasesList = ({ cardsData }) => {
  const transformedCardsData = useMemo(() => transformCardsData(cardsData), [cardsData]);

  return (
    <Grid
      w="full"
      templateColumns={{ mobile: '1fr', tablet: 'repeat(2, 1fr)' }}
      gap={{ mobile: '16px', laptop: '20px' }}
    >
      {transformedCardsData.map((cardData, i) => (
        <ProjectsCasesCard
          key={cardData.link}
          isBigCard={(i + 1) % 5 === 0 && cardData?.description}
          {...cardData}
        />
      ))}
    </Grid>
  );
};

export default memo(CasesList);
